import {
  Button,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Textarea,
} from "@chakra-ui/react";

export interface CompOffForm {
  email: string;
  date: string; // date worked (YYYY-MM-DD)
  reason: string;
}

interface GrantCompOffModalProps {
  isOpen: boolean;
  onClose: () => void;
  value: CompOffForm;
  onChange: (value: CompOffForm) => void;
  onSubmit: () => void;
  employees: { email: string; name?: string }[];
}

/** Admin form to grant one Compensatory Off day for a day worked. */
export const GrantCompOffModal = ({
  isOpen,
  onClose,
  value,
  onChange,
  onSubmit,
  employees,
}: GrantCompOffModalProps) => (
  <Modal isOpen={isOpen} onClose={onClose} isCentered>
    <ModalOverlay />
    <ModalContent borderRadius="14px">
      <ModalHeader fontSize="18px">Grant Comp-Off</ModalHeader>
      <ModalCloseButton />
      <ModalBody>
        <FormControl mb={3} isRequired>
          <FormLabel fontSize="13px">Employee</FormLabel>
          <Select
            size="sm"
            placeholder="Select employee"
            value={value.email}
            onChange={(e) => onChange({ ...value, email: e.target.value })}
          >
            {employees.map((emp) => (
              <option key={emp.email} value={emp.email}>
                {emp.name ? `${emp.name} (${emp.email})` : emp.email}
              </option>
            ))}
          </Select>
        </FormControl>
        <FormControl mb={3} isRequired>
          <FormLabel fontSize="13px">Date worked</FormLabel>
          <Input
            size="sm"
            type="date"
            value={value.date}
            onChange={(e) => onChange({ ...value, date: e.target.value })}
          />
        </FormControl>
        <FormControl isRequired>
          <FormLabel fontSize="13px">Reason</FormLabel>
          <Textarea
            size="sm"
            value={value.reason}
            onChange={(e) => onChange({ ...value, reason: e.target.value })}
          />
        </FormControl>
      </ModalBody>
      <ModalFooter gap={2}>
        <Button size="sm" variant="outline" onClick={onClose}>
          Cancel
        </Button>
        <Button
          size="sm"
          bg="#327171"
          color="white"
          _hover={{ bg: "#285e5e" }}
          onClick={onSubmit}
        >
          Grant
        </Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
);
